import { NavigateOptions, useSearchParams } from "react-router-dom"

export function useURLSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const setParams = (
    payload: Record<string, string | undefined>,
    // Forwarded to react-router (e.g. { replace: true } to update params
    // without pushing a history entry). Defaults unchanged: a push.
    navigateOptions?: NavigateOptions,
  ) => {
    setSearchParams(prev => {
      Object.keys(payload).forEach(key => {
        if (payload[key]) {
          prev.set(key, payload[key] ?? "")
        } else {
          prev.delete(key)
        }
      })
      return prev
    }, navigateOptions)
  }

  return {
    params: Object.fromEntries(searchParams.entries()),
    setParams,
  }
}

export function useQueryParams() {
  const [searchParams] = useSearchParams()
  return Object.fromEntries(searchParams.entries())
}
